import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaDownload, FaEnvelope, FaArrowRight, FaGithub, FaLinkedin, FaFacebook, FaTwitter } from 'react-icons/fa';

const TypingEffect = ({ words }) => {
  const [index, setIndex] = useState(0);
  const [text, setText] = useState('');
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    const current = words[index % words.length];
    const timeout = setTimeout(() => {
      if (!deleting) {
        setText(current.substring(0, text.length + 1));
        if (text === current) setTimeout(() => setDeleting(true), 2000);
      } else {
        setText(current.substring(0, text.length - 1));
        if (text === '') { setDeleting(false); setIndex(i => i + 1); }
      }
    }, deleting ? 50 : 100);
    return () => clearTimeout(timeout);
  }, [text, deleting, index, words]);

  return <span className="typing-text">{text}<span className="cursor">|</span></span>;
};

const Hero = ({ profile }) => {
  const typingWords = [
    profile?.title || 'Full Stack Web Developer',
    'MERN Stack Expert',
    'WordPress Developer',
    'SEO Specialist'
  ];

  return (
    <section className="hero" id="home">
      {/* Floating Particles */}
      <div className="particles">
        {[...Array(20)].map((_, i) => (
          <div key={i} className="particle" style={{
            left: `${Math.random() * 100}%`, top: `${Math.random() * 100}%`,
            width: `${Math.random() * 6 + 2}px`, height: `${Math.random() * 6 + 2}px`,
            animationDelay: `${Math.random() * 5}s`, animationDuration: `${Math.random() * 10 + 10}s`
          }} />
        ))}
      </div>

      <div className="container">
        <motion.div className="hero-content"
          initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
          <motion.p className="greeting" initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.3 }}>
            👋 Hello, I'm
          </motion.p>
          <h1>
            <span className="highlight">{profile?.name || 'Asif'}</span>
          </h1>
          <div className="tagline">
            <TypingEffect words={typingWords} />
          </div>
          <p>{profile?.bio || 'I build modern, scalable web applications and provide professional digital services. From frontend to backend, WordPress to SEO — I deliver complete solutions for your business.'}</p>

          {/* Social Icons */}
          <div className="hero-social">
            {profile?.social?.github && <a href={profile.social.github} target="_blank" rel="noreferrer"><FaGithub /></a>}
            {profile?.social?.linkedin && <a href={profile.social.linkedin} target="_blank" rel="noreferrer"><FaLinkedin /></a>}
            {profile?.social?.facebook && <a href={profile.social.facebook} target="_blank" rel="noreferrer"><FaFacebook /></a>}
            {profile?.social?.twitter && <a href={profile.social.twitter} target="_blank" rel="noreferrer"><FaTwitter /></a>}
          </div>

          <div className="hero-buttons">
            <Link to="/services" className="btn btn-primary">
              <FaArrowRight /> View Services
            </Link>
            <a href="#contact" className="btn btn-outline">
              <FaEnvelope /> Hire Me
            </a>
            {profile?.resumeUrl && (
              <a href={profile.resumeUrl} className="btn btn-glass" target="_blank" rel="noreferrer">
                <FaDownload /> Resume
              </a>
            )}
          </div>
        </motion.div>

        <motion.div className="hero-visual"
          initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.8, delay: 0.3 }}>
          <div className="hero-shape">
            <div className="code-icon">{'</>'}</div>
            {/* Orbiting tech icons */}
            <div className="orbit">
              <div className="orbit-item" style={{ '--i': 0 }}>⚛️</div>
              <div className="orbit-item" style={{ '--i': 1 }}>🟢</div>
              <div className="orbit-item" style={{ '--i': 2 }}>🍃</div>
              <div className="orbit-item" style={{ '--i': 3 }}>🔷</div>
              <div className="orbit-item" style={{ '--i': 4 }}>📱</div>
              <div className="orbit-item" style={{ '--i': 5 }}>🔍</div>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <div className="scroll-indicator">
        <div className="mouse"><div className="wheel"></div></div>
        <p>Scroll Down</p>
      </div>
    </section>
  );
};

export default Hero;
